export default {
  SURVEY: (state, survey) => (state.surveyData = survey),
  SUCCESS_SUBMIT_SURVEY: (state, success_submit_survey) =>
    (state.success_submit_survey = success_submit_survey),
  ERR_SURVEY: (state, err_survey) => (state.err_survey = err_survey),
  AVAILABLE_SURVEYS: (state, available_surveys) =>
    (state.available_surveys = available_surveys),
};
